<mat-card class="mat-elevation-z0">
    <mat-card-header>
        <mat-card-title>{{'test-model.title' | translate}}</mat-card-title>
        <mat-card-subtitle>{{'test-model.subtitle' | translate}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content style="text-align: center;">
        <mat-form-field class="full-width">
            <input name="testText" [(ngModel)]="testText" matInput placeholder="{{'test-model.term' | translate}}"
                value="">
        </mat-form-field>
    </mat-card-content>

    <mat-card-actions class="action-centered">
        <button matTooltip="{{'test-model.test.hint' | translate}}" (click)="test()"
            mat-raised-button>{{'test-model.test' | translate}}
        </button>

        <button matTooltip="{{ 'test-model.makeScratch.hint' | translate}}" (click)="loadScratch()"
            matTooltip="Hacer un programa en Scratch con este modelo" mat-raised-button>
            <img src="assets/images/scratch_icon.svg">
        </button>


    </mat-card-actions>

</mat-card>

<mat-card *ngIf="prediction" class="test-card">
    <mat-card-content>
            <p>{{confidenceText}}</p>
            <ul>
                <li *ngFor="let item of prediction">
                    {{item[0] }} ({{item[1] * 100 | number:'1.2-2'}} %)
                    <mat-progress-bar [value]="item[1] * 100">
                    </mat-progress-bar>
                </li>
            </ul>
    </mat-card-content>

</mat-card>
